/* shto-scp-hero: the background video. Nothing of it loads before the page has loaded (the poster photo is what shows
   first); then the phone- or desktop-sized file is picked, it plays muted on a loop, fades in over the poster once it is
   really playing, rests while the hero is off screen and can't be paused. If the browser refuses to play it, the poster stays. */
(function () {
  if (window.ShtoScpHero) return;
  window.ShtoScpHero = true;

  /* 2026-10-21 (Karina): the hero video can't be paused. There is no pause / play button any more, and a choice saved
     by the old button earlier in the visit is forgotten. The video only rests while the hero is scrolled off screen or
     the tab is hidden (saves the phone's battery), and plays again the moment it is back. Anything else that pauses it
     (a click, another script, the browser) is undone straight away. */
  try { sessionStorage.removeItem('shtoMotionPaused'); } catch (e) {}
  document.documentElement.classList.remove('shto-motion-paused');
  var nativePause = HTMLMediaElement.prototype.pause;
  function rest(v) { v.shtoResting = true; nativePause.call(v); }
  function lock(v) {
    if (v.shtoLocked) return;
    v.shtoLocked = true;
    v.controls = false;
    v.removeAttribute('controls');
    // Only this script may pause it, and only while it is off screen or the tab is hidden.
    try { v.pause = function () {}; } catch (e) {}
    v.addEventListener('pause', function () {
      if (v.shtoResting || document.hidden || v.shtoVisible === false) return;
      setTimeout(function () { if (v.paused && !document.hidden && v.shtoVisible !== false) play(v); }, 0);
    });
    // Some browsers show controls on their own (e.g. after a failed autoplay): never keep them.
    v.addEventListener('play', function () { if (v.controls) v.controls = false; });
  }
  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('.shto-scp-hero [data-shto-bg-video]').forEach(function (v) {
      if (!v.shtoStarted) return;
      if (document.hidden) rest(v); else if (v.shtoVisible !== false) play(v);
    });
  });

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target.shtoVideo;
      if (!v || !v.shtoStarted) return;
      v.shtoVisible = e.isIntersecting;
      if (e.isIntersecting) play(v); else if (!v.paused) rest(v);
    });
  }, { threshold: 0 }) : null;

  function play(v) {
    v.shtoResting = false;
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  var mq = function (q) { return window.matchMedia(q).matches; };
  // Which copy fits this screen. data-phone-crop: the phone copy is the 3:4 middle of the frame, only right up to that width.
  function pick(v) {
    var crop = v.getAttribute('data-phone-crop');
    var phoneMax = crop ? crop : '599';
    var key = mq('(min-width: 990px)') ? 'data-src-desktop' : mq('(max-width: ' + phoneMax + 'px)') ? 'data-src-phone' : 'data-src-mobile';
    var src = v.getAttribute(key) || v.getAttribute('data-src-mobile') || v.getAttribute('data-src-desktop');
    return { src: src, crop: !!crop && key === 'data-src-phone' };
  }
  function load(v) {
    var p = pick(v);
    if (!p.src) return false;
    v.classList.toggle('shto-scp-hero__video--crop', p.crop);
    v.shtoCrop = p.crop;
    v.src = p.src;
    return true;
  }

  function start(v) {
    if (v.shtoStarted) return;
    // Visitors who asked for less motion keep the still poster (nothing of the video downloads).
    if (mq('(prefers-reduced-motion: reduce)')) return;
    // Phones that asked to save data keep the poster.
    if (!mq('(min-width: 990px)') && navigator.connection && navigator.connection.saveData) return;
    var fallback = v.getAttribute('data-src-fallback') || v.getAttribute('data-src-desktop');
    v.shtoStarted = true;
    lock(v);
    v.muted = true;
    v.setAttribute('muted', '');
    v.addEventListener('playing', function () { v.classList.add('shto-scp-hero__video--on'); });
    // A lighter copy that isn't there: play Shopify's file instead.
    v.addEventListener('error', function () {
      if (v.shtoFellBack || !fallback || v.getAttribute('src') === fallback) return;
      v.shtoFellBack = true;
      v.classList.remove('shto-scp-hero__video--crop');
      v.src = fallback;
      play(v);
    });
    v.preload = 'auto';
    if (!load(v)) { v.shtoStarted = false; return; }
    // Turning a phone sideways past the crop width (or back): switch to the copy that fits.
    if (v.getAttribute('data-phone-crop') && window.matchMedia) {
      var m = window.matchMedia('(max-width: ' + v.getAttribute('data-phone-crop') + 'px)');
      var swap = function () {
        if (v.shtoFellBack) return;
        var p = pick(v);
        if (p.crop === v.shtoCrop && v.getAttribute('src') === p.src) return;
        var t = v.currentTime || 0;
        v.classList.remove('shto-scp-hero__video--on');
        load(v);
        v.addEventListener('loadedmetadata', function once() { v.removeEventListener('loadedmetadata', once); try { v.currentTime = t; } catch (e) {} }, { once: true });
        if (v.shtoVisible !== false) play(v);
      };
      if (m.addEventListener) m.addEventListener('change', swap); else if (m.addListener) m.addListener(swap);
    }
    var media = v.closest('.shto-scp-hero__media');
    if (io && media) { media.shtoVideo = v; io.observe(media); }
    else play(v);
  }
  function init(scope) {
    (scope || document).querySelectorAll('.shto-scp-hero [data-shto-bg-video]').forEach(start);
  }
  // After the page's load, when the browser is idle (at the latest 3 s in). Tried 2026-10-10: attaching it as soon as the
  // poster has painted starts it no sooner on a throttled phone (the store's own scripts hold the main thread until load).
  function later() {
    if ('requestIdleCallback' in window) requestIdleCallback(function () { init(); }, { timeout: 1500 });
    else setTimeout(init, 200);
  }
  if (document.readyState === 'complete') later();
  else {
    window.addEventListener('load', later);
    setTimeout(function () { init(); }, 3000);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
